<template>
  <div class="page">
    <section class="card">
      <h1 class="title">{{ t('eventExplorer') }}</h1>
      <p class="subtitle">{{ t('enterSlug') }}</p>
      <form class="slug-form" @submit.prevent="goToEvent">
        <label class="field">
          <span>{{ t('eventSlug') }}</span>
          <input v-model.trim="eventSlug" type="text" placeholder="yaz-galasi" required />
        </label>
        <button class="primary" type="submit">{{ t('openEvent') }}</button>
      </form>
    </section>
    <section class="hint">
      <h2>{{ t('pages') }}</h2>
      <ul>
        <li>{{ t('eventPage') }}: <code>/events/:eventSlug</code></li>
        <li>{{ t('winnerPage') }}: <code>/events/:eventSlug/winner</code></li>
        <li>{{ t('itemQuestions') }}: <code>/events/:eventSlug/items/:itemShortCode</code></li>
        <li>{{ t('itemSubmitted') }}: <code>/events/:eventSlug/items/:itemShortCode/submitted</code></li>
      </ul>
    </section>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from '../i18n'

export default {
  name: 'HomePage',
  setup() {
    const router = useRouter()
    const { t } = useI18n()
    const eventSlug = ref('')

    const goToEvent = () => {
      if (!eventSlug.value) return
      router.push({ name: 'event', params: { eventSlug: eventSlug.value } })
    }

    return {
      t,
      eventSlug,
      goToEvent
    }
  }
}
</script>

<style scoped>
.page {
  display: grid;
  gap: 24px;
}

.card {
  background: #ffffff;
  border-radius: 16px;
  padding: 28px;
  box-shadow: 0 12px 40px rgba(15, 23, 42, 0.08);
}

.title {
  font-size: 28px;
  margin: 0 0 8px;
}

.subtitle {
  margin: 0 0 20px;
  color: #64748b;
}

.slug-form {
  display: grid;
  gap: 16px;
}

.field {
  display: grid;
  gap: 8px;
  font-weight: 600;
  color: #0f172a;
}

input {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px 14px;
  font-size: 16px;
}

.primary {
  background: #2563eb;
  border: none;
  color: #ffffff;
  padding: 12px 18px;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
}

.primary:hover {
  background: #1d4ed8;
}

.hint {
  color: #475569;
}

.hint ul {
  padding-left: 18px;
}

code {
  background: #f1f5f9;
  padding: 2px 6px;
  border-radius: 6px;
}
</style>
